import { Progress } from 'antd';
import * as React from 'react';

interface SaveOfflineLoaderProps {
  current: number;
  total: number;
}

export default function SaveOfflineLoader({ current, total }: SaveOfflineLoaderProps) {
  const style: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999
  }

  const progressPercent = total > 0 ? Math.round((current / total) * 100) : 0;

  return (
    <div style={style}>
      <div className="loader" style={{ 
        width: '80%',
        maxWidth: '400px',
        margin: "auto",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        textAlign: 'center'
      }}>
        <div style={{ 
          color: 'white', 
          fontSize: '22px', 
          marginBottom: '20px',
          fontWeight: 'bold'
        }}>
          Please wait while trees are being saved offline
        </div>
        
        <div style={{ width: '100%', marginBottom: '20px' }}>
          <Progress 
            percent={progressPercent} 
            showInfo={false} 
            strokeColor="#1890ff" 
            trailColor="rgba(255,255,255,0.3)"
          />
        </div>

        <div style={{ 
          color: 'white', 
          fontSize: '22px', 
          fontWeight: 'bold'
        }}>
          {current} / {total}
        </div>
      </div>
    </div>
  );
}
